import { postDataPromise } from 'brock-fetch-utils';
import getUri from '../utils/getUri';

export function getIsFavorite(itemKey, parameterId) {
    return postDataPromise(getUri('SmartSuiteMenuApi'), {
        method: 'getIsFavorite',
        payload: {
            itemKey,
            parameterId,
            url: window.location.href,
        },
    });
}

export function saveFavorite(
    itemKey,
    favoriteName,
    source,
    parameterId,
    viewKey,
    parameterDescription
) {
    return postDataPromise(getUri('SmartSuiteMenuApi'), {
        method: 'saveFavorite',
        payload: {
            itemKey,
            viewKey,
            parameterId,
            parameterDescription,
            favoriteName,
            source,
            url: window.location.href,
        },
    });
}

export function deleteFavorite(itemKey, favoriteName, source, parameterId) {
    return postDataPromise(getUri('SmartSuiteMenuApi'), {
        method: 'deleteFavorite',
        payload: {
            itemKey,
            parameterId,
            favoriteName,
            source,
            url: window.location.href,
        },
    });
}

export function getLandingPageWidgetUserFavorites() {
    return postDataPromise(getUri('SmartSuiteMenuApi'), {
        method: 'getLandingPageWidgetUserFavorites',
    });
}
